import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e79dd4c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "font-weight-bold"
}
const _hoisted_3 = {
  key: 1,
  class: "font-weight-bold"
}
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = {
  key: 1,
  class: "table-container"
}
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["colspan"]
const _hoisted_23 = { class: "flexCenter" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "SsEmpDetailTitle" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "상세정보")
], -1))
const _hoisted_25 = { class: "SsEmpDetailContent" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "SsEmpDetailTitle" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "계좌정보")
], -1))
const _hoisted_29 = { class: "SsEmpDetailContent" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "SsEmpDetailTitle" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "메모"),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10px","opacity":"0.8"} }, "(300자)")
], -1))
const _hoisted_31 = {
  key: 0,
  class: "memoSpainner text-center SsEmpDetailMemo"
}
const _hoisted_32 = {
  key: 1,
  class: "SsEmpDetailMemo"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "SsEmpDetailTitle" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "상태변경")
], -1))
const _hoisted_34 = { class: "SsEmpDetailContent" }
const _hoisted_35 = ["onUpdate:modelValue", "onChange"]
const _hoisted_36 = ["value"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-left":"10px"} }, "직원 검색 필터", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "직원 상태", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "직원 직위", -1))

import { computed, onMounted, onUnmounted, ref } from "vue";
import { mdiMagnify } from "@mdi/js";
import axios from "axios";
import AdminLoadingAction from "../../../components/admin/layout/AdminLoadingAction.vue";
import { useStore } from 'vuex';
import AdminEmpDetail from "../../../components/admin/basic-info/AdminEmpDetail.vue";

interface Employee {
  emp_num: string;
  emp_name: string;
  emp_job: string;
  emp_birth_num_front: string;
  emp_phone: string;
  emp_email: string;
  emp_addr: string;
  emp_bank: string;
  emp_in_date: string;
  emp_status: number;
  emp_memo?: string;
  status_name?: string;
  [key: string]: string | number | undefined;
}

interface Header {
  title: string;
  key: string;
  align: string;
  sortable: boolean;
}

interface EmpItem {
  emp_num: string;
  emp_name: string;
  emp_job: string;
}

interface HeaderItem {
  title: string;
  key: string;
  align: string;
  sortable: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmpBasicInfo',
  setup(__props) {

const store = useStore();
const editingMode = ref(false);
const editingModeFalse = async () => {
  editingMode.value = false;
};
let originalEmp = ref("");
let originalMemo = ref("");

const loading = ref(false);
const memoLoading = ref(false);
const empList = ref<Employee[]>([]);
const code = ref<string>(store.state.AdminSisulCode);
const search = ref("");
const dialog = ref(false);

const selectStatus = ref<number[]>([1, 2, 3, 0]);
const statusOptions = [
  { label: "현원", value: 1 },
  { label: "유급휴가", value: 2 },
  { label: "무급휴가", value: 3 },
  { label: "퇴사", value: 0 },
];
const statusOptions2 = ["현원", "유급휴가", "무급휴가","퇴사"];
const selectJob = ref<string[]>([
  "시설장",
  "사회복지사",
  "간호사",
  "간호조무사",
  "물리치료사",
  "사무장",
  "사무원",
  "영양사",
  "조리사",
  "조리원",
  "위생원",
  "요양보호사",
  "운전사",
  "기타",
]);
const jobOptions = [
  { label: "시설장", value: "시설장" },
  { label: "사회복지사", value: "사회복지사" },
  { label: "간호사", value: "간호사" },
  { label: "간호조무사", value: "간호조무사" },
  { label: "물리치료사", value: "물리치료사" },
  { label: "사무장", value: "사무장" },
  { label: "사무원", value: "사무원" },
  { label: "영양사", value: "영양사" },
  { label: "조리사", value: "조리사" },
  { label: "조리원", value: "조리원" },
  { label: "위생원", value: "위생원" },
  { label: "요양보호사", value: "요양보호사" },
  { label: "운전사", value: "운전사" },
  { label: "기타", value: "기타" },
];
const allSelectDie = () => {
  selectStatus.value = [];
  selectJob.value = [];
};
const headersArr = ref<Header[]>([
  { title: "No.", key: "index", align: "center", sortable: false },
  { title: "사원번호", key: "emp_num", align: "center", sortable: true },
  { title: "이름", key: "emp_name", align: "center", sortable: true },
  { title: "직위", key: "emp_job", align: "center", sortable: true },
  { title: "생년월일", key: "emp_birth_num_front", align: "center", sortable: true },
  { title: "휴대폰", key: "emp_phone", align: "center", sortable: true },
  { title: "이메일", key: "emp_email", align: "center", sortable: true },
  { title: "주소", key: "emp_addr", align: "center", sortable: true },
  { title: "은행", key: "emp_bank", align: "center", sortable: true },
  { title: "입사일", key: "emp_in_date", align: "center", sortable: true },
  { title: "상태", key: "emp_status", align: "center", sortable: true },
  { title: "기능", key: "", align: "center", sortable: false },
]);
const filteredItems = computed(() => {
  const hasStatusFilter = selectStatus.value.length > 0;
  const hasJobFilter = selectJob.value.length > 0;

  if (!hasStatusFilter && !hasJobFilter) {
    return [];
  }

  return empList.value.filter((item) => {
    let searchTerm: string | null = null;
    if (!search.value) {
      searchTerm = search.value;
    } else {
      searchTerm = search.value.trim().toLowerCase();
    }

    const matchesSearch =
      !searchTerm ||
      (item.emp_name && item.emp_name.toLowerCase().includes(searchTerm)) ||
      (item.emp_job && item.emp_job.toLowerCase().includes(searchTerm));

    const matchesStatus =
      !hasStatusFilter || selectStatus.value.includes(item.emp_status);

    const matchesJobs = !hasJobFilter || selectJob.value.includes(item.emp_job);

    return matchesSearch && matchesStatus && matchesJobs;
  });
});
// const show = ref(false);
const showVal = () => {
  // show.value = !show.value
};
const expandedRows = ref([] as number[]);
const toggleRowDetails = (item: Employee, index: number) => {
  showVal();
  editingMode.value = true;
  selectedRowIndex.value = index;
  store.commit("setSsECDEmpInfo", item);
};
const focusMemo = (item: Employee) => {
  originalEmp.value = item.emp_num;
  originalMemo.value = item.emp_memo || '';
};
const updateEmpMemo = async (item: Employee) => {
  if (memoLoading.value === true) return;

  if (item.emp_memo === originalMemo.value && item.emp_num === originalEmp.value) {
    return;
  }
  if (!item.emp_memo || item.emp_memo === "") {
    item.emp_memo = "isNullTextPOSTMEMO";
  }
  try {
    const empMemo = encodeURIComponent(item.emp_memo);
    memoLoading.value = true;
    const response = await axios.post(
      `/api/updateEmpMemo/${empMemo}/${item.emp_num}/${code.value}`
    );
    const result = response.data;
    if (result.success) {
      await readEmpInfo();
    }
  } catch (error) {
    console.error(error);
    throw error;
  } finally {
    memoLoading.value = false;
  }
};

const updateEmpStatus = async (item: Employee) => {
  try {
    let empStatus = 0;
    if (item.status_name === "현원") {
      empStatus = 1;
    } else if (item.status_name === "유급휴가") {
      empStatus = 2;
    } else if (item.status_name === "무급휴가") {
      empStatus = 3;
    }
    const response = await axios.post(
      `/api/updateEmpStatus/${empStatus}/${item.emp_num}/${code.value}`
    );
    const result = response.data;
    if (result.success) {
      await readEmpInfo();
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};
const readEmpInfo = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get(`/api/readEmpInfo/${code.value}`);
    const responseData = response.data;
    if (responseData) {
      empList.value = responseData;

      return responseData;
    } else {
      console.error("에러가 발생했습니다.");
    }
  } catch (error) {
    console.error("errorMsg:", error);
  } finally {
    loading.value = false;
    distroyHandleRowClick();
  }
};
//수정로직
const selectedRowIndex = ref<number | null>(null);
const handleRowClick = (item: EmpItem, index: number) => {
  selectedRowIndex.value = index;
  store.commit("setSsECDEmpInfo", item);
};

const handleRowClickBlank = () => {
  selectedRowIndex.value = null;
  store.commit("setSsECDEmpInfo", []);
};
const distroyHandleRowClick = () => {
  selectedRowIndex.value = null;
  store.commit("setSsECDEmpInfo", "notSelectStatus");
};
const updateHeadersArr = ref<HeaderItem[]>([
  { title: "사원번호", key: "emp_num", align: "center", sortable: true },
  { title: "이름", key: "emp_name", align: "center", sortable: true },
  { title: "직위", key: "emp_job", align: "center", sortable: true },
]);
//수정로직

onMounted(async () => {
  await readEmpInfo();
  store.commit("setSsECDEmpInfo", []);
});
onUnmounted(() => {
  loading.value = false;
  sessionStorage.removeItem("getSsECDEmpInfo");
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (loading.value)
    ? (_openBlock(), _createBlock(AdminLoadingAction, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_v_container, {
          fluid: "",
          class: "pa-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "rounded-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-account-group")
                        ]),
                        _: 1
                      }),
                      (!editingMode.value)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "사원 목록"))
                        : _createCommentVNode("", true),
                      (editingMode.value)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "사원 등록 및 수정"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      (editingMode.value)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "btnColorWhite mr-2",
                            text: "목록으로 돌아가기",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (editingModeFalse()))
                          }))
                        : _createCommentVNode("", true),
                      (!editingMode.value)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            class: "btnColorWhite mr-2",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (editingMode.value = true))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 등록 ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (dialog.value = true)),
                        class: "btnColorWhite mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("필터")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_text_field, {
                        class: "inoutSearchInput ml-2",
                        style: {"background-color":"#fff","max-width":"200px","width":"auto","min-width":"190px"},
                        modelValue: search.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search).value = $event)),
                        color: "#0f7545",
                        label: "이름/직위 검색",
                        "single-line": "",
                        clearable: "",
                        "append-inner-icon": _unref(mdiMagnify),
                        flat: "",
                        "hide-details": "auto",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue", "append-inner-icon"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (editingMode.value === true)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          class: "nonPM"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "3" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_sheet, { style: {"border-right":"1px solid #e6deef"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_data_table, {
                                      "no-data-text": "사원을 등록해주세요.",
                                      "fixed-header": "",
                                      density: "compact",
                                      scrollable: "",
                                      headers: updateHeadersArr.value,
                                      items: filteredItems.value,
                                      search: search.value,
                                      "item-value": "name",
                                      class: "SsEmpWorkPayTypeTb SsEmpListTb fontNotoSans400",
                                      "items-per-page": -1,
                                      "items-per-page-options": [
                    { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' },
                  ]
                                    }, {
                                      item: _withCtx(({ item, index }) => [
                                        _createElementVNode("tr", {
                                          class: _normalizeClass(['SsEmpListTbTr', { selected: selectedRowIndex.value === index }]),
                                          onClick: () => handleRowClick(item, index)
                                        }, [
                                          _createElementVNode("td", _hoisted_6, _toDisplayString(item.emp_num), 1),
                                          _createElementVNode("td", _hoisted_7, _toDisplayString(item.emp_name), 1),
                                          _createElementVNode("td", _hoisted_8, _toDisplayString(item.emp_job), 1)
                                        ], 10, _hoisted_5)
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items", "search", "items-per-page-options"]),
                                    _createVNode(_component_v_btn, {
                                      onClick: _cache[4] || (_cache[4] = () => handleRowClickBlank()),
                                      color: "#333",
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("사원등록")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "9" }, {
                              default: _withCtx(() => [
                                _createVNode(AdminEmpDetail, { onSuccess: readEmpInfo })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (editingMode.value === false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_v_data_table, {
                            "no-data-text": "사원을 등록해주세요.",
                            "fixed-header": "",
                            density: "compact",
                            scrollable: "",
                            headers: headersArr.value,
                            items: filteredItems.value,
                            search: search.value,
                            "item-value": "name",
                            class: "adminDataTb custom-table",
                            "items-per-page": -1,
                            "items-per-page-options": [
                { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
              ]
                          }, {
                            item: _withCtx(({ item, index }) => [
                              _createElementVNode("tr", {
                                class: _normalizeClass([{ activeSsTr: expandedRows.value.includes(index) }, "SsTbTr"])
                              }, [
                                _createElementVNode("td", _hoisted_10, _toDisplayString(index + 1), 1),
                                _createElementVNode("td", _hoisted_11, _toDisplayString(item.emp_num || ""), 1),
                                _createElementVNode("td", _hoisted_12, _toDisplayString(item.emp_name || ""), 1),
                                _createElementVNode("td", _hoisted_13, _toDisplayString(item.emp_job || ""), 1),
                                _createElementVNode("td", _hoisted_14, _toDisplayString(item.emp_birth_num_front || ""), 1),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(item.emp_phone?.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3") || ""), 1),
                                _createElementVNode("td", _hoisted_16, _toDisplayString(item.emp_email || ""), 1),
                                _createElementVNode("td", null, _toDisplayString(item.emp_addr || ""), 1),
                                _createElementVNode("td", null, [
                                  _createTextVNode(_toDisplayString(item.emp_bank), 1),
                                  (item.emp_bank_num)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "(" + _toDisplayString(item.emp_bank_num) + ")", 1))
                                    : _createCommentVNode("", true),
                                  (item.emp_bank_owner)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "(" + _toDisplayString(item.emp_bank_owner) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_19, _toDisplayString(item.emp_in_date || ""), 1),
                                _createElementVNode("td", _hoisted_20, [
                                  (item.emp_status === 0)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        color: "black"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.status_name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (item.emp_status === 1)
                                      ? (_openBlock(), _createBlock(_component_v_chip, {
                                          key: 1,
                                          color: "green-darken-4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.status_name), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : (item.emp_status === 2)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 2,
                                            color: "orange-darken-4"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.status_name), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (item.emp_status === 3)
                                          ? (_openBlock(), _createBlock(_component_v_chip, {
                                              key: 3,
                                              color: "blue-darken-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.status_name), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", {
                                  class: "text-center",
                                  onClick: ($event: any) => (toggleRowDetails(item, index))
                                }, [
                                  _createVNode(_component_v_btn, {
                                    class: "toggleRowDetailsBtn",
                                    color: "grey-lighten-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("수정")
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_21)
                              ], 2),
                              _createElementVNode("td", {
                                class: "bonusTd",
                                colspan: headersArr.value.length
                              }, [
                                _createVNode(_component_v_expand_transition, null, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_23, [
                                        _hoisted_24,
                                        _createVNode(_component_v_divider, {
                                          inset: "",
                                          vertical: "",
                                          class: "SsVerticalDivider"
                                        }),
                                        _createElementVNode("div", _hoisted_25, [
                                          (item.emp_birth_num)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, " 주민번호 : " + _toDisplayString(`${item.emp_birth_num?.slice(0, 6)}-*******` || null), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_27)),
                                          _createElementVNode("p", null, "자택주소 : " + _toDisplayString(item.emp_addr), 1),
                                          _withDirectives(_createElementVNode("p", null, "퇴사일자 : " + _toDisplayString(item.emp_out_date), 513), [
                                            [_vShow, item.emp_out_date]
                                          ])
                                        ]),
                                        _hoisted_28,
                                        _createVNode(_component_v_divider, {
                                          inset: "",
                                          vertical: "",
                                          class: "SsVerticalDivider"
                                        }),
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("p", null, "사용은행 : " + _toDisplayString(item.emp_bank), 1),
                                          _createElementVNode("p", null, "계좌번호 : " + _toDisplayString(item.emp_bank_num), 1),
                                          _createElementVNode("p", null, "예금주명 : " + _toDisplayString(item.emp_bank_owner), 1)
                                        ]),
                                        _hoisted_30,
                                        (memoLoading.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_31))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                              _createVNode(_component_v_textarea, {
                                                modelValue: item.emp_memo,
                                                "onUpdate:modelValue": ($event: any) => ((item.emp_memo) = $event),
                                                rows: "2",
                                                variant: "outlined",
                                                maxlength: "300",
                                                width: "300px",
                                                "hide-details": "auto",
                                                onFocus: ($event: any) => (focusMemo(item)),
                                                onBlur: ($event: any) => (updateEmpMemo(item))
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                                            ])),
                                        _hoisted_33,
                                        _createVNode(_component_v_divider, {
                                          inset: "",
                                          vertical: "",
                                          class: "SsVerticalDivider"
                                        }),
                                        _createElementVNode("div", _hoisted_34, [
                                          _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": ($event: any) => ((item.status_name) = $event),
                                            onChange: ($event: any) => (updateEmpStatus(item)),
                                            style: {"cursor":"pointer","border":"1px solid #454545","padding":"6px 10px","border-radius":"5px"}
                                          }, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions2, (status) => {
                                              return _createElementVNode("option", {
                                                class: "text-center",
                                                key: status,
                                                value: status
                                              }, _toDisplayString(status), 9, _hoisted_36)
                                            }), 64))
                                          ], 40, _hoisted_35), [
                                            [_vModelSelect, item.status_name]
                                          ])
                                        ])
                                      ])
                                    ], 512), [
                                      [_vShow, expandedRows.value.includes(index)]
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 8, _hoisted_22)
                            ]),
                            _: 1
                          }, 8, ["headers", "items", "search", "items-per-page-options"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_dialog, {
          modelValue: dialog.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialog).value = $event)),
          height: "800px",
          class: "fontNotoSans400"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "SsFilterCard" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "SsFilterCardTitle text-center" }, {
                  default: _withCtx(() => [
                    _hoisted_37,
                    _createVNode(_component_v_btn, {
                      style: {"float":"right","margin-right":"10px"},
                      class: "btnColorWhite",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (allSelectDie()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("전체 체크해제")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _hoisted_38,
                            _createVNode(_component_v_sheet, { class: "filter-sheet" }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, (status) => {
                                  return _createElementVNode("div", {
                                    key: status.value,
                                    class: "inline-div"
                                  }, [
                                    _createVNode(_component_v_checkbox, {
                                      color: "secondary",
                                      label: status.label,
                                      modelValue: selectStatus.value,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectStatus).value = $event)),
                                      value: status.value,
                                      "hide-details": "",
                                      size: "small"
                                    }, null, 8, ["label", "modelValue", "value"])
                                  ])
                                }), 64))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _hoisted_39,
                            _createVNode(_component_v_sheet, { class: "filter-sheet" }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(jobOptions, (job) => {
                                  return _createElementVNode("div", {
                                    key: job.value,
                                    class: "inline-div"
                                  }, [
                                    _createVNode(_component_v_checkbox, {
                                      label: job.label,
                                      modelValue: selectJob.value,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectJob).value = $event)),
                                      value: job.value,
                                      "hide-details": "",
                                      size: "small"
                                    }, null, 8, ["label", "modelValue", "value"])
                                  ])
                                }), 64))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (dialog.value = false)),
                      class: "cancelRegistBtn",
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("확인")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 64))
}
}

})